import { GamepadAxisEvent } from 'gamepad.js';
import { GamepadAnalogInput } from '../types/inputs.types';
import { InputActions } from '@game-libs/models';

export const inputToActionsMap = {
  keyboard: {
    Space: [InputActions.SELECT, InputActions.JUMP],
    Enter: [InputActions.SELECT],
    KeyE: [InputActions.INTERACT],
    Escape: [InputActions.PAUSE, InputActions.BACK, InputActions.CANCEL],
    KeyP: [InputActions.PAUSE],
    KeyW: [InputActions.MOVE_UP],
    KeyA: [InputActions.MOVE_LEFT],
    KeyS: [InputActions.MOVE_DOWN],
    KeyD: [InputActions.MOVE_RIGHT],
    ArrowUp: [InputActions.MOVE_UP],
    ArrowLeft: [InputActions.MOVE_LEFT],
    ArrowDown: [InputActions.MOVE_DOWN],
    ArrowRight: [InputActions.MOVE_RIGHT],
    KeyZ: [InputActions.ATTACK],
    KeyX: [InputActions.DEFEND],
    KeyC: [InputActions.SPECIAL, InputActions.DASH],
    KeyV: [InputActions.OTHER1],
  },
  gamepadButton: {
    A: [InputActions.SELECT, InputActions.JUMP],
    B: [InputActions.DEFEND, InputActions.BACK],
    Y: [InputActions.INTERACT],
    X: [InputActions.ATTACK],
    LB: [InputActions.PAGE_DOWN],
    RB: [InputActions.PAGE_UP, InputActions.SPECIAL],
    MENU: [InputActions.PAUSE],
    ArrowUp: [InputActions.MOVE_UP],
    ArrowLeft: [InputActions.MOVE_LEFT],
    ArrowDown: [InputActions.MOVE_DOWN],
    ArrowRight: [InputActions.MOVE_RIGHT],
    ToggleView: [InputActions.OPTIONS],
  },
  gamepadStick: {
    LPAD_RIGHT: [InputActions.MOVE_RIGHT],
    LPAD_LEFT: [InputActions.MOVE_LEFT],
    LPAD_UP: [InputActions.MOVE_UP],
    LPAD_DOWN: [InputActions.MOVE_DOWN],
    LPAD_H_RETURN: [InputActions.MOVE_RIGHT, InputActions.MOVE_LEFT],
    LPAD_V_RETURN: [InputActions.MOVE_UP, InputActions.MOVE_DOWN],
    RPAD_RIGHT: [],
    RPAD_LEFT: [],
    RPAD_UP: [],
    RPAD_DOWN: [],
    RPAD_H_RETURN: [],
    RPAD_V_RETURN: [],
  },
};

type InputIcons = Partial<
  Record<
    InputActions,
    {
      keyboard: keyof typeof inputToActionsMap.keyboard;
      gamepad: keyof typeof inputToActionsMap.gamepadButton;
    }
  >
>;

export const inputIcons: InputIcons = {
  [InputActions.INTERACT]: { keyboard: 'KeyE', gamepad: 'Y' },
};

export const gamepadButtonsMap = [
  'A',
  'B',
  'Y',
  'X',
  'LB',
  'RB',
  ,
  ,
  ,
  'MENU',
  'LSB',
  'RSB',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  '',
  'ToggleView',
  '',
];

export function getAxisEvent(
  event: GamepadAxisEvent
): GamepadAnalogInput | undefined {
  const { axis, value } = event.detail;

  switch (axis) {
    case 0:
      // leftStickVector.x = value;
      if (value > 0) {
        return 'LPAD_RIGHT';
      }
      if (value < 0) {
        return 'LPAD_LEFT';
      }
      return 'LPAD_H_RETURN';
    case 1:
      // leftStickVector.y = value;
      if (value > 0) {
        return 'LPAD_DOWN';
      }
      if (value < 0) {
        return 'LPAD_UP';
      }
      return 'LPAD_V_RETURN';
    case 4:
      // rightStickVector.x = value;
      if (value > 0) {
        return 'RPAD_RIGHT';
      }
      if (value < 0) {
        return 'RPAD_LEFT';
      }
      return 'RPAD_H_RETURN';
    case 5:
      // rightStickVector.y = value;
      if (value > 0) {
        return 'RPAD_DOWN';
      }
      if (value < 0) {
        return 'RPAD_UP';
      }
      return 'RPAD_V_RETURN';
  }
  return undefined;
}
